// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../CommunityWebPortal/_app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-active[data-v-d96dd86e]:hover{opacity:.6;background:#ccc}", ""]);
// Exports
module.exports = exports;
